export function latRad(lat): number {
    const sin = Math.sin((lat * Math.PI) / 180);
    const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
    return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
  }

  export function calculateMapZoom(
    pointA: google.maps.LatLngLiteral,
    pointB: google.maps.LatLngLiteral
  ): number {
    const latDif = Math.abs(latRad(pointA.lat) - latRad(pointB.lat));
    const lngDif = Math.abs(pointA.lng - pointB.lng);

    const latFrac = latDif / Math.PI;
    const lngFrac = lngDif / 360;

    const lngZoom = Math.log(1.001 / latFrac) / Math.log(2);
    const latZoom = Math.log(1.001 / lngFrac) / Math.log(2);
    let returnedZoom = Math.min(lngZoom, latZoom);
    if (returnedZoom > 15 || returnedZoom === Infinity) {
      returnedZoom = 15;
    }
    return returnedZoom - 0.5;
  }
